import script from "./ArtistsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistsSection.vue?vue&type=script&setup=true&lang=js"

import "./ArtistsSection.vue?vue&type=style&index=0&id=67cc7fa1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cc7fa1"]])

export default __exports__